import { withInlineValidation } from '@/components/forms/wrappers/withInlineValidation';

import { TextInput } from './textInput/textInput.writer';
import { TextArea } from './textArea/textArea.writer';
import { SelectMenu } from './selectMenu/selectMenu.writer';
import { MultiSelectMenu } from './multiSelectMenu/multiSelectMenu.writer';
import { DateEntry } from '@/components/forms/components/form/writer/widgets/dateEntry/dateEntry.writer';
import { Radio } from './radio/radio.writer';
import { NumericInputWidget } from './numericInput/numericInput.writer';
import { CheckboxWidget } from './checkbox/checkbox.writer';
import { CheckboxesWidget } from './checkboxes/checkboxes.writer';
import { SlateWidget } from './slate/slate.writer';
import { GroupSelection } from './groupSelection/groupSelection.writer';
import { RegistryWidgetsType } from '@rjsf/utils';

export const widgets = {
  CheckboxWidget: CheckboxWidget,
  CheckboxesWidget: withInlineValidation(CheckboxesWidget),
  draft: withInlineValidation(SlateWidget),
  NumericWidget: withInlineValidation(NumericInputWidget),
  RadioWidget: withInlineValidation(Radio),
  SelectWidget: withInlineValidation(SelectMenu),
  MultiSelectWidget: withInlineValidation(MultiSelectMenu),
  textarea: withInlineValidation(TextArea),
  TextWidget: withInlineValidation(TextInput),
  'alt-date': withInlineValidation(DateEntry),
  'workflow-group': withInlineValidation(GroupSelection)
} as const satisfies Record<
  string,
  React.FC<any>
> as unknown as RegistryWidgetsType;
